const { connect } = require('react-redux');
const { context } = require('app-context');
const EditGroupPage = require('../components/EditGroupPage');

const actions = context.actions;
const selectors = context.selectors.all;

module.exports = connect(
    (state, { isCreate, match: { params } }) => ({
        groupDetails: isCreate ? null : selectors.getGroup_forGroupEdit(state, params.id),
        schoolRoles: selectors.getSchoolRoles_ForCreateGroup(state),
        schoolName: selectors.getCurrentSchoolName(state),
        isCompany: selectors.getSchoolIsCompany(state),
        isCommunity: selectors.getSchoolIsCommunity(state),
        isSchoolOnline: selectors.getSchoolIsOnline(state),
        schoolEnableReactions: selectors.getSchoolEnableReactions(state),
        schoolEnableGroupGifs: selectors.getSchoolEnableGroupGifs(state)
    }),
    (dispatch, { isCreate }) => ({
        onSubmit: (data) => dispatch(isCreate ? actions.classes.create(data) : actions.classes.update(data))
    })
)(EditGroupPage);
